import { render, staticRenderFns } from "./CustomFormCheckboxElement.vue?vue&type=template&id=194b94b5"
import script from "./CustomFormCheckboxElement.vue?vue&type=script&lang=js"
export * from "./CustomFormCheckboxElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports